export enum ClockLocationRequirement {
    ClockAnywhere = 0,
    ClockByIPAddress = 1,
    ClockByCookie = 2,
    ClockByGeoLocation = 4,
    EmployeeOverrideClockLocationRequirement = 8,
}
